<!-- About: SecondaryNavigation.vue
  /**
  * Currently unused.
  */
-->

<template>
  <div>
    <h2>Shop Categories</h2>
    <hr>
    <ul class="secondary-navigation">
      <li :class="currentShopPage === '/shop/powder-coating-colors' ? 'active' : ''">
        <a href="/shop/powder-coating-colors">Powder Coat Colors</a>
      </li>
      <li :class="currentShopPage === '/shop/color-match' ? 'active' : ''">
        <a href="/shop/color-match">Color Match</a>
      </li>
      <li :class="currentShopPage === '/shop/powder-coating-creations' ? 'active' : ''">
        <a href="/shop/powder-coating-creations">Creations</a>
      </li>
      <li :class="currentShopPage === '/shop/powder-coating-swatch-sets' ? 'active' : ''">
        <a href="/shop/powder-coating-swatch-sets">Swatch Sets</a>
      </li>
      <!-- <li :class="currentShopPage === '/shop/powder-coating-kits' ? 'active' : ''">
        <a href="/shop/powder-coating-kits">Kits</a>
      </li> -->
      <li :class="currentShopPage === '/shop/gear-apparel' ? 'active' : ''">
        <a href="/shop/gear-apparel">Gear / Apparel</a>
      </li>
      <li :class="currentShopPage === '/shop/powder-coating-equipment' ? 'active' : ''">
        <a href="/shop/powder-coating-equipment">Equipment</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'SecondaryNavigation',

    computed: {
      currentShopPage() {
        return window.location.pathname;
      }
    }
  }
</script>

<style lang="scss" scoped>
  h2 {
    margin: 0;
  }
  hr {
    margin: 10px 0;
  }
  .secondary-navigation {
    list-style-type: none;

    li {
      padding-bottom: 5px;
      height: 30px;

      a {
        color: #4a4a4a;
      }

      &.active {
        font-weight: bold;
      }
    }
  }
</style>
